module.exports = __webpack_public_path__ + "static/media/photo255.5b7f72b0.jpg";